module.exports = __webpack_public_path__ + "../static/media/TitilliumWeb-Bold.a9f517c1.ttf";